<template lang="pug">
  validation-observer(ref='validation')
    .container-listagem
      el-row
        el-col
          Pesquisa(
            placeHolder = "Informe o Cartório ou Município ou nº do Ofício",
            @search="handlePesquisa"
            @resetSearch="resetPesquisa"
            :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
          )

      el-card.default-card(shadow="hover" :body-style="{height: '100%', display: 'flex', 'flex-direction': 'column'}")
        div.container(v-if="podeGerarOficio")
          el-button.left-align(
            type="primary",
            @click="goToEmissaoOficio",
            :disabled=false
            name="oficio"
          )
            span.center
              i.fa.fa-file-alt
              b &nbsp Gerar Ofício

        app-divider-refresh-button(
          :label="label",
          @click="resetPesquisa",
          :hasButton="true"
          content="Atualizar ofícios"
        )

        .container-table
          table-generica(
            :colunas="colunas",
            :botoesAcao="botoesAcao",
            :sortChanged='sortChanged',
            :dados='oficios'
          )
          app-paginacao(
            :total="total"
            :pagina="pagina",
            @changePage="changePage"
          )

      app-buttons-cadastro(
        :isPrimeiroPasso="true",
        :isUltimoPasso="true",
        :showButtonSalvar="false",
        @cancelar="cancelar",
        @finalizar="finalizar"
      )

</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import CONFIGS from '@/constants/configs'
import Utils from '@/utils/utils'
import StatusOficio from '@/constants/statusOficioArrecadacao'
import FileHelper from '@/utils/fileHelper'
import statusProcesso from '@/constants/statusProcessoArrecadacao'
import cloneDeep from 'lodash/cloneDeep'
import TableGenerica from '@/components/TableGenerica'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

const DESPACHO_EMPTY = {
  texto: null,
  documento: null,
  processoId: null,
  despachoId: null,
  acao: null
}

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  simplificado: false
}

export default {
  data () {
    return {
      radiosAcoes: [],
      radioInicial: null,
      despacho: cloneDeep(DESPACHO_EMPTY),
      colunas: [
        {
          prop: 'numeroOficio',
          label: 'Ofício',
          sortable: 'custom'
        },
        {
          prop: 'cartorio.nome',
          label: 'Cartório',
          sortable: 'custom'
        },
        {
          prop: 'cartorio.municipio.nome',
          label: 'Município',
          sortable: 'custom'
        },
        {
          prop: 'status.nome',
          label: 'Situação',
          sortable: 'custom'
        },
        {
          prop: 'tipo.nome',
          label: 'Tipo',
          sortable: 'custom'
        }
      ],
      processo: {
        numeroProcesso: ''
      },
      despachos: {},
      oficios: [],
      total: 0,
      filtro: cloneDeep(FILTRO_EMPTY),
      historicoDespachos: [],
      Utils,
      statusProcesso: statusProcesso
    }
  },
  mixins: [AppNotificacao],
  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    TableGenerica,
    AppRadiosTramitacao,
    AppButtonsCadastro,
    AppLabel
  },

  computed: {
    pagina () {
      return this.filtro.pagina + 1
    },

    label () {
      return `Listagem dos Ofícios do Processo ${this.processo.numeroProcesso}`
    },

    podeGerarOficio () {
      if (this.oficios.length) {
        return (
          (this.processo.status === statusProcesso.EM_EMISSAO_OFICIO_CN ||
            this.processo.status ===
              statusProcesso.AGUARDANDO_RETORNO_CARTORIO) &&
          this.oficios[0].tipo?.codigo === 'CERTIDAO_NEGATIVA'
        )
      }
      return false
    }
  },

  methods: {
    setDespacho (despacho) {
      this.despacho = {
        texto: despacho.texto,
        documento: despacho.documento,
        processoId: this.processo.id,
        despachoId: despacho.id,
        acao: despacho.acao
      }
    },
    analisarProcesso () {
      this.$router.push({
        name: 'oficios/validacaoCadastro',
        query: {
          idProcesso: this.despacho.processoId
        }
      })
    },
    cancelar () {
      this.confirmBox(
        'Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.',
        this.$messages.TITULO_WARNING,
        () => {
          this.goToHome()
        },
        () => {},
        'Sim',
        'Não'
      )
    },
    async finalizar () {
      this.confirmBox(
        this.$messages.MSG_CONFIRMACAO,
        this.$messages.TITULO_WARNING,
        () => {
          this.analisarProcesso()
        },
        () => {},
        'Confimar',
        'Cancelar'
      )
    },
    changeRadio (value) {
      this.radioInicial = value.acao
      this.despacho.acao = value.acao
    },
    async setRadios (idProcesso) {
      this.radios = await this.tarefa({ processo: idProcesso })
      this.radiosAcoes = this.radios.acoes
    },
    sortChanged ({ column, prop, order }) {
      if (order) {
        const direcaoMap = {
          ascending: 'ASC',
          descending: 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getOficios()
    },

    ...mapActions({
      tarefa: 'processoArrecadacao/tarefa',
      findOficios: 'oficioArrecadacao/find',
      getPDFCertidaoNegativa: 'oficioArrecadacao/getPDFCertidaoNegativa',
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      findProcessoById: 'processoArrecadacao/findById',
      tramitarComAcao: 'processoArrecadacao/tramitarComAcao'
    }),

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.filtro.simplificado = false
      this.changePage(1)
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.filtro.simplificado = true
      this.getOficios()
    },

    formatMunicipio (row, column, prop) {
      if (prop) {
        return prop?.length === 0 ? '-' : prop[0].nome
      }

      return '-'
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.getOficios()
    },

    goToConversa (oficio) {
      this.$router.push({
        name: 'cartorio/conversa',
        query: {
          protocolo: oficio.protocolo,
          idProcesso: this.processo.id
        }
      })
    },

    goToEmissaoOficio () {
      this.$router.push({
        name: 'cpat/oficio',
        query: {
          idProcesso: this.processo.id,
          botaoEmitirOficio: true
        }
      })
    },

    async download (oficio) {
      const bytes = await this.getPDFCertidaoNegativa(oficio.id)

      FileHelper.saveFile(bytes, 'oficio_certidao_negativa.pdf')
    },

    botoesAcao (oficio) {
      const acoes = []
      const codigoStatus = oficio.status?.codigo

      if (codigoStatus !== StatusOficio.EM_ANDAMENTO) {
        acoes.push({
          click: this.download.bind(this, oficio),
          icon: 'get_app',
          title: 'Download ofício',
          active: true
        })
      }

      if (
        codigoStatus === StatusOficio.AGUARDANDO_RESPOSTA_DO_CARTORIO ||
        codigoStatus === StatusOficio.AGUARDANDO_RESPOSTA_SICARF ||
        codigoStatus === StatusOficio.FINALIZADO
      ) {
        acoes.push({
          click: this.goToConversa.bind(this, oficio),
          icon: 'comment',
          title: 'Conversa cartório',
          active: true
        })
      }

      return acoes
    },

    getOficios () {
      this.findOficios(this.filtro).then(response => {
        this.oficios = response.oficios
        this.total = response.total
      })
    },

    goToHome () {
      this.$router.push({
        name: 'cpat/home'
      })
    }
  },

  created () {
    this.setMainCardVisibility(false)
    const query = this.$route.query
    if (query.idProcesso) {
      this.setRadios(query.idProcesso)
      this.findProcessoById(query.idProcesso)
        .then(processo => {
          this.processo = processo
          this.filtro.idProcesso = query.idProcesso
          this.despacho.processoId = query.idProcesso
          this.getOficios()
        })
        .catch(() => {
          this.goToHome()
        })
    } else {
      this.goToHome()
    }
  }
}
</script>

<style lang="scss" scoped>
.container-table {
  height: 100%;
}

.container {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}

.container-button {
  padding-top: 10px;
}

.left-align {
  align-self: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/Oficios.vue